/* Token */
$.ajaxPrefilter(function(options, originalOptions, xhr){
	return xhr.setRequestHeader('X-XSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
});